import React, { useState } from "react";
import { Search } from "react-feather";
import { useQuery } from "react-query";
import { Col, Container, Row } from "reactstrap";
import { HeaderSection } from "../../components/shared/HeaderSection";
import { CardTouristic } from "../../components/tourism/CardTouristic";
import { LoadMoreButtons } from "../../components/tourism/LoadMoreButtons";
import { TouristSearch } from "../../components/tourism/TouristSearch";

import ROUTES from "../../routes/routes";
import { getTouristAtractives } from "../../services/tourismService";

const Atractives = () => {
  const [activateSearch, setActivateSearch] = useState(false);
  const [newUrl, setNewUrl] = useState(null);

  const colorAtractives = "#F61959";

  const { isLoading, isError, data, isFetching } = useQuery(
    ["atractives", newUrl],
    () => getTouristAtractives(newUrl),
    { keepPreviousData: true }
  );

  if (isLoading) return <p>Cargando</p>;
  if (isFetching) return <p>Loading feaching...</p>;
  if (isError) return <p>error</p>;

  return (
    <>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorAtractives}
      />
      <Container>
        <Row>
          <Col md="9">
            <h3
              className="subheader-main"
              style={{ borderColor: colorAtractives }}
            >
              Atractivos Turisticos
            </h3>
          </Col>
          <Col md="3" style={{ textAlign: "right", paddingTop: "2em" }}>
            <Search
              size={32}
              color={colorAtractives}
              onClick={() => setActivateSearch(true)}
            />
          </Col>
        </Row>
        {activateSearch ? (
          <TouristSearch
            stateUrl={setNewUrl}
            stateActivateSearch={setActivateSearch}
          />
        ) : null}
        <CardTouristic
          data={data.results}
          bgBtnColor={colorAtractives}
          routeDetail={ROUTES.ATRACTIVE_DETAIL}
        />
        <LoadMoreButtons
          setUrl={setNewUrl}
          previous={data.previous}
          next={data.next}
        />
      </Container>
      <HeaderSection
        route={ROUTES.TOURISM}
        resume={"Volver a Turismo"}
        bgBtnColor={colorAtractives}
      />
    </>
  );
};

export default Atractives;
